export const dropAnimation = {
  initial: {y: -10, opacity: 0, transition: {duration: 0.15}},
  animate: {y: 0, opacity: 1, transition: {duration: 0.2}},
  exit: {y: -20, opacity: 0, transition: {duration: 0.15}},
};